import React from 'react'

//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';


//Translate utils :
import { translator } from "../../../utils/translator.js"

//import { useSelector, useDispatch } from "react-redux";
import { getLang, getLocation, getStepLocation, getPanier } from "../../../store/selectors.js"; //global state : shopping state
import { locationSlice } from '../../../store/locationSlice.js';
import { panierSlice } from '../../../store/panierSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//utils
import { getTotalPanier, getArticlePU, tarifDecimalConverter } from '../../../utils/calcul-tarif'
import VignettePhotoCarousel from '../vignettePhotoCarousel/VignettePhotoCarousel.jsx';

import { poucesConvertor } from "../../../utils/poucesConvertor.js"


export default function PanierList({ dbArticles, dbTailles, panierAMatcher, locAMatcher }) {

    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : shopping step
    let panier = useSelector(getPanier) //global state : shopping step
    if (panierAMatcher) { panier = panierAMatcher }
    let location = useSelector(getLocation) //global state : shopping step
    if (locAMatcher) { location = locAMatcher }

    const [totalPanier, setTotalPanier] = useState({ total: 0, difference: 0, combos: 0 })


    useEffect(() => {

        setTotalPanier(getTotalPanier(dbArticles, panier, location));

    }, [panier, location])


    function getArticleQty() {
        let qty = 0
        panier.forEach(article => {
            qty += article.qte;
        })
        return qty;
    }

    function getArticle(item) {
        return dbArticles.find(article => article.id_article === item.article_id)
    }

    function changeQty(direction, item) {

        if (direction > 0) { //on ajoute
            if (item.qte <= 0) { //création
                dispatch(panierSlice.actions.insertArticle(
                    { ...item, qte: 1 }));
            } else {//increment
                dispatch(panierSlice.actions.incrementArticleQty({
                    id: item.article_id,
                    taille: item.taille_id
                }));

            }

        } else { //on retire
            if (item.qte <= 1) { //suppression
                dispatch(panierSlice.actions.deleteArticle({
                    id: item.article_id,
                    taille: item.taille_id
                }));
            } else {//decrement
                dispatch(panierSlice.actions.decrementArticleQty({
                    id: item.article_id,
                    taille: item.taille_id
                }));

            }

        }

    }

    function removeItem(item) {
        dispatch(panierSlice.actions.deleteArticle({
            id: item.article_id,
            taille: item.taille_id
        }));
    }

    function getTailleInfo(taille) {
        let info = dbTailles.find(t => t.id_taille === taille).nom_taille;
        return poucesConvertor(info)
    }

    return (
        <div className="location-panier-list">
            {panier.toSorted((a1, a2) => a1.article_id < a2.article_id ? -1 : 1).map((item, index) => (
                <div
                    key={index}
                    className="location-panier-list-item">

                    <div className="location-panier-list-item-left">
                        <div className="location-panier-list-item-vignette">
                            <VignettePhotoCarousel article={getArticle(item)} mode="panier" />
                        </div>

                        <div className="location-panier-list-rubrique-info">
                            <h3>{getArticle(item).Type.nom_type} {getArticle(item).Categorie.nom_categorie}</h3>
                            <p><strong>{getArticle(item).description}</strong>  {getArticle(item).infos}</p>

                        </div>

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>{translator("Taille", lang, "panierListSize")}</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ht">{getTailleInfo(item.taille_id)}</p>
                            </div>
                        </div>
                    </div>


                    <div className="location-panier-list-item-center">

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>{translator("Quantité", lang, "panierListQty")}</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom no-padding-lateral">
                                <div className="location-panier-list-rubrique-bottom-select-qte ">
                                    {!panierAMatcher &&
                                        <Button
                                            variant="contained"
                                            size="small"
                                            disabled={item.qte <= 0}
                                            onClick={_ => changeQty(-1, item)}><RemoveIcon />
                                        </Button>
                                    }
                                    <p>{item.qte}</p>
                                    {!panierAMatcher &&
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={_ => changeQty(1, item)}><AddIcon />
                                        </Button>
                                    }
                                </div>

                            </div>
                        </div>
                        {/*  <div className="rubrique-delete">
                            <Button className="bt-delete"
                                onClick={_ => removeItem(item)}><DeleteForeverIcon /></Button>
                        </div>
 */}
                    </div>


                    <div className="location-panier-list-item-right">

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>P.U.</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-u">{tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location))}€</p>
                            </div>
                        </div>


                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>Prix HT</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ht">{tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte / 1.2)}€</p>
                            </div>
                        </div>

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>{translator("Prix TTC", lang, "panierListTTC")}</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ttc">{tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte)}€</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}


            {totalPanier.combos > 0 ?

                <div className="location-panier-list-item item-kit">

                    <div className="location-panier-list-item-left">

                        <div className="location-panier-list-rubrique-info">
                            <h3>{translator("KITS PLANCHE+COMBI", lang, "recapPanierkit")}</h3>
                            <p>{translator("Réductions appliquées pour les ensembles planche & combinaison", lang, "recapPanierkit2")}</p>

                        </div>
                    </div>


                    <div className="location-panier-list-item-center">


                    </div>


                    <div className="location-panier-list-item-right">

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>P.U.</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-u">- {tarifDecimalConverter(totalPanier.difference)}€</p>
                            </div>
                        </div>


                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>{translator("Quantité", lang, "panierListQty")}</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ht">{totalPanier.combos}</p>
                            </div>
                        </div>

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>Total Discount</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ttc">- {tarifDecimalConverter(totalPanier.difference * totalPanier.combos)}€</p>
                            </div>
                        </div>
                    </div>
                </div>
                : null}

            {panier.length > 0 ?

                <div className="location-panier-list-item item-total">

                    <div className="location-panier-list-item-left">

                        <div className="location-panier-list-rubrique-info">
                            <h3>{translator("TARIF TOTAL DU PANIER", lang, "recapPanierMontant")}</h3>

                        </div>
                    </div>


                    <div className="location-panier-list-item-center">


                    </div>


                    <div className="location-panier-list-item-right">


                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>Total HT</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ht">{tarifDecimalConverter((totalPanier.total - totalPanier.difference * totalPanier.combos) / 1.2)}€</p>
                            </div>
                        </div>

                        <div className="location-panier-list-rubrique">
                            <div className="location-panier-list-rubrique-top">
                                <p>{translator("Total TTC", lang, "panierListTTC")}</p>
                            </div>
                            <div className="location-panier-list-rubrique-bottom">
                                <p className="prix-ttc">{tarifDecimalConverter(totalPanier.total - totalPanier.difference * totalPanier.combos)}€</p>
                            </div>
                        </div>
                    </div>
                </div>
                : null}

        </div>
    )
}
